import * as React from "react";
import { Grid, useTheme } from "@mui/material";
import { PageContainer } from "#pages/PageContainer";
import { useDispatch } from "react-redux";
import { deriveValues, WordCloud, WordCloudResponsive } from "@inode/wordcloud";

export const SiteMap = () => {
    const dispatch = useDispatch();

    const words = React.useMemo(() => {
        return deriveValues(
            `Ontology Development and Metadata Standards
Data Standards, Data Collection, Interfaces
ontology ontology ontology ontology
metadata metadata
Data Analysis, Quality Management and Re-Use
Linked Extensible Infrastructure and Access Management Data & Meta Data Standards Data Science & Information Infrastructure Design 20.01.2022 DOI: 10.5281/zenodo.5882747
Dissemination and Outreach/ Training
Networking with NFDIs, SFBs and International
Intellectual Property and Confidentiality, Licences and Reward models
Management
Electronic Lab Notebooks
Chemistry Repositories
Data Management Plans
Knowledge Base
Terminology Service
Helpdesk
Digitisation and Enrichment
Standards, Data Quality and Curation
Research Tools and Data Services
Data Publication and Data Availability
Legal Helpdesk (legal questions and ethics)
Data Literacy
Research Funding

Ontology, Knowledge Graph and Reconciliation Services
Storage and computing resources for the analysis of big, unstructured data
Legal questions regarding data science
Training and further education in data science and data literacy
Mannheim Web Panel, a data set extracted from company websites
Central web portal: centralized access to NFDI4Microbiota services.
Analytical services: developing and maintaining workflows.
Databases & Terminology Services: supporting database development and best practices.
Data Quality & Provenance Services: laying the groundwork for interpretable, comparable and valid research results.
Data Deposition & Repositories: fostering best practices for depositing data in repositories.
Long-term preservation: raising awareness about and promoting the standardized long-term preservation of metadata.
Reviewing/Commenting System for Data: gathering feedback to adjust the NFDI4Microbiota platform to researchers’ needs.
Systems biology, modeling, and multi-omics integration: developing mechanisms for mapping linkages between different data types and inter-omic integration between reference databases and the NFDI4Microbiota system.
Electronic Lab Notebook (ELN): fostering the use and educating about ELNs.
M2.1 – Data & Metadata Standards: promoting the use of relevant data and metadata requirements.
M2.2 – Experimental Procedure Standards: promoting the use of appropriate experimental protocols.
M2.3 – Workflow Standards: promoting the use of suitable analytical approaches.
M2.4 – Policies and legal issues for data management and re-use: ensuring open access, reproducibility, consistency, transparency, and interoperability.
`,
            undefined,
            { stemmer: "porter", allowNumbers: false }
        );
    }, []);

    const theme = useTheme();
    return (
        <PageContainer>
            <Grid container spacing={1}>
                <WordCloudResponsive
                    words={words}
                    options={{
                        rotations: 0,
                        fontSizes: [32, 192],
                        fontFamily: theme.typography.fontFamily,
                        spiral: "rectangular",
                        scale: "linear",
                        enableTooltip: false,
                        maxLayoutAttempts: 2,
                    }}
                    maxHeight={"50vh"}
                />
            </Grid>

            {/*<Stack divider={<Divider />}>*/}
            {/*    <Typography variant="h1">Documentation</Typography>*/}

            {/*    <List>*/}
            {/*        {Object.values(Routes)*/}
            {/*            .filter(x => x.visible)*/}
            {/*            .map(x => (*/}
            {/*                <ListItem*/}
            {/*                    button*/}
            {/*                    key={x.path}*/}
            {/*                    onClick={() => dispatch(push(x.path))}*/}
            {/*                >*/}
            {/*                    <ListItemIcon>*/}
            {/*                        <Folder />*/}
            {/*                    </ListItemIcon>*/}
            {/*                    <ListItemText primary={x.label} />*/}
            {/*                </ListItem>*/}
            {/*            ))}*/}
            {/*    </List>*/}
            {/*</Stack>*/}
        </PageContainer>
    );
};
